
<div class="pg-pc" :class="star">
  <div class="logo"></div>
  <div class="name"></div>
  <a class="home" href="https://yszt.ztgame.com/index.shtml" target="_blank"></a>
  <a class="download" href="https://yszt.ztgame.com/download/" target="_blank"></a>
  <div class="qrcode">
    <vue-qr :text="addr" class="code" margin="12" :backgroundColor="'#fff7f4'" :colorLight="'#fff7f4'"></vue-qr>
    <div class="title"></div>
  </div>
  <!-- <div class="text">请使用手机微信扫码访问</div> -->
</div>
